import { AssinaturaStatusResponse } from "../types/billing.types";

export const RECURSO_CIRURGIA = "pacotes_cirurgia";
export const RECURSO_OPME = "pacotes_opme";

export type RecursoKit = typeof RECURSO_CIRURGIA | typeof RECURSO_OPME;

export function usoDeKits(billing: AssinaturaStatusResponse | null | undefined): Record<string, number> {
  return billing?.uso ?? billing?.uso_free ?? {};
}

/** `undefined` = sem teto (Profissional ou billing ainda não carregou). */
export function limiteDeKit(
  billing: AssinaturaStatusResponse | null | undefined,
  recurso: RecursoKit,
): number | undefined {
  const limites = billing?.limites;
  if (limites == null) return undefined;
  return limites[recurso];
}

export function podeCriarKit(
  billing: AssinaturaStatusResponse | null | undefined,
  recurso: RecursoKit,
): boolean {
  const limite = limiteDeKit(billing, recurso);
  if (limite === undefined) return true;
  return (usoDeKits(billing)[recurso] ?? 0) < limite;
}
